import _ from 'lodash';
import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {COLORS} from '@/utils/constants';

const options = [
    {
        name: 'Local (within the city)',
        value: 'Item 1',
    },
    {
        name: 'Local (in a rural area)',
        value: 'Item 2',
    },
    {
        name: 'Regional',
        value: 'Item 3',
    },
    {
        name: 'National',
        value: 'Item 4',
    },
    {
        name: 'Pan-African',
        value: 'Item 5',
    },
    {
        name: 'Outside Africa',
        value: 'Item 6',
    },
];

const findIndex = (submission: any, key: string) =>
    options.findIndex((option, index) => submission[`${key}_${index}`] === option.value)

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: What are the geographical areas of your business operations?
 * 
 * == baseline
 * question16_*5
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: What are the geographical areas of your business operations?
 * 
 * == final
 * question78_*5
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursWhoIncreasedGeographicalAreaOfActivityChartCalculation = (props: any) => {
    const groupedBaselineSubmissions = _.keyBy(props.baselineSubmissions, 'uoa_id');
    const groupedFinalSubmissions = _.keyBy(props.finalSubmissions, 'uoa_id');

    const mergedSubmissions = _.mergeWith(
        groupedBaselineSubmissions,
        groupedFinalSubmissions,
        (baselineSubmission, finalSubmission) => ({baselineSubmission, finalSubmission})
    );

    let increased = 0;
    let notIncreased = 0;
    let missing = 0;

    for (const uoaId in mergedSubmissions) {
        const item = mergedSubmissions[uoaId];

        if (item.baselineSubmission && item.finalSubmission) {
            const baselineIndex = findIndex(item.baselineSubmission, 'question16');
            const finalIndex = findIndex(item.finalSubmission, 'question78');

            if (baselineIndex === -1 || finalIndex === -1) {
                missing++;
            } else {
                baselineIndex >= finalIndex ? notIncreased++ : increased++;
            }
            
        } else {
            missing++;
        }
    }

    const data = [
        {
            name: 'Increased',
            color: COLORS.e4ImpactBlue,
            y: increased
        },
        {
            name: 'Not increased',
            color: COLORS.e4ImpactOrange,
            y: notIncreased
        }
    ];

    return getDefaultPieFormatting(
        'KPI: % of entrepreneurs who increased the geographical area of activity',
        data,
        0,
        {},
    ) as Highcharts.Options;
}